<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M33.1 20.08a1.51 1.51 0 00-2.12 0l-9.31 9.31A1.5 1.5 0 0022.73 32h18.61a1.5 1.5 0 001.06-2.56z"/><path d="M57 21.2H47L33.41 7.62a2 2 0 00-2.82 0L17 21.2H7a2 2 0 00-2 2V53a2 2 0 002 2h50a2 2 0 002-2V23.2a2 2 0 00-2-2zM24 40.41h6.5V52H24zM33.5 52V40.41H40V52zM56 52H43V39.41a2 2 0 00-2-2H23a2 2 0 00-2 2V52H8V24.2h10.22l.88-.88L32 10.41l12.9 12.91.88.88H56z"/></svg>